import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'
import { BaseClient } from '../domain/client'
import {
  UserSearchCriteria,
  BaseUser,
  UpdateUserPayload,
  ResponseResetPassword,
  ResponseRestoreUser
} from '../domain/user'
import { UserRepository } from '../domain/user.repository'

export const odinUserRepository: UserRepository = {
  getUsers: async (filters: UserSearchCriteria): Promise<BaseUser[]> => {
    const request: HttpRequest = {
      method: 'GET',
      endpoint: '/odin/api/users'
    }

    let queryParams = {
      limit: filters.pagination.limit,
      page: filters.pagination.page
    }

    if (filters.email) {
      queryParams['email'] = filters.email
    }

    if (filters.groupId) {
      queryParams['groupId'] = filters.groupId
    }

    if (filters.status) {
      queryParams['status'] = filters.status
    }

    const result = await AvtGateway.executeGetRequest<any>({
      ...request,
      queryParams
    })

    const users = result.map((user) => ({
      ...user,
      avtRole: {
        ...user.avtRole,
        superAdmin: user.avtRole.super_admin
      }
    }))

    users.forEach((user) => {
      delete user.avtRole.super_admin
    })

    return users as BaseUser[]
  },
  getUserById: async (userId: string): Promise<BaseUser> => {
    const request: HttpRequest = {
      method: 'GET',
      endpoint: `/odin/api/users/${userId}`
    }

    const result = await AvtGateway.executeGetRequest({
      ...request
    })

    return result as BaseUser
  },
  createUser: async (user: BaseUser): Promise<BaseUser> => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/odin/api/users`
    }

    let result
    try {
      result = await AvtGateway.executePostRequest({
        ...request,
        body: user
      })
    } catch (error) {
      throw error
    }

    return result as BaseUser
  },
  updateUserV3: async (userId: string, payload: UpdateUserPayload): Promise<boolean> => {
    const request: HttpRequest = {
      method: 'PATCH',
      endpoint: `/odin/api/v3/users/${userId}`,
      body: payload
    }

    const result = await AvtGateway.executePatchRequest<any>({
      ...request
    })

    return result.ok
  },
  changeUserClient: async (userId: string, client: BaseClient): Promise<void> => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/odin/api/users/change-client/${userId}`,
      body: {
        clientId: client.id,
        codename: client.clientNumber
      }
    }

    await AvtGateway.executePostRequest(request)
  },
  deleteUsersInBatch: async (ids: number[]) => {
    const request: HttpRequest = {
      method: 'DELETE',
      endpoint: `/odin/api/users`,
      body: { ids }
    }

    await AvtGateway.executeDeleteRequest(request)
  },
  resetPassword: async (userId: number): Promise<ResponseResetPassword> => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/odin/api/users/${userId}/reset-password`
    }

    const result = await AvtGateway.executePostRequest<ResponseResetPassword>({
      ...request
    })

    return result
  },
  restoreUser: async (email: string): Promise<ResponseRestoreUser> => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/odin/api/users/restore`,
      body: { email }
    }

    const result = await AvtGateway.executePostRequest<ResponseRestoreUser>({
      ...request
    })

    return result
  }
}
